export default __webpack_public_path__ + "static/media/open_eye.4efb4a87.svg";